
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ValidationRule } from 'vuelidate/lib/validators'

enum MeasurementUnits {
  mm = 1,
  cm = 10,
  m = 1000
}

@Component
export default class LengthMeasurementField extends Vue {
  @Prop() modelValue!: string | null
  @Prop({ default: () => [] }) rules?: ValidationRule[]
  @Prop({ default: '' }) label?: string
  @Prop({ required: true }) disabled!: boolean
  @Prop({ default: false }) disableMeasurementUnitSelection?: boolean
  @Prop({ validator: (input: string) => ['mm', 'cm', 'm'].includes(input), default: 'mm' })
  defaultMeasurementUnit?: string

  measurementUnit = 1
  measurementUnits = [
    {
      text: 'mm',
      value: 1
    },
    {
      text: 'cm',
      value: 10
    },
    {
      text: 'm',
      value: 1000
    }
  ]

  @Watch('defaultMeasurementUnit', { immediate: true })
  onDefaultMeasurementUnitChange(unit: string) {
    this.measurementUnit = MeasurementUnits[unit as keyof typeof MeasurementUnits]
  }

  get displayValue() {
    return this.recalculateDisplayValue()
  }

  set displayValue(value: string | null) {
    value = value === null ? value : value.replace(',', '.')
    const displayVal = Number(value)
    if (value === null || !value?.length || isNaN(displayVal)) {
      this.$emit('update:modelValue', null)
      return
    }

    const emitVal = (displayVal * this.measurementUnit).toString()
    this.$emit('update:modelValue', emitVal)
  }

  recalculateDisplayValue() {
    const modelVal = Number(this.modelValue)
    if (this.modelValue === null || isNaN(modelVal)) return null

    return (modelVal / this.measurementUnit).toString()
  }

  rulesInternal = {
    allowAnything: () => {
      return true
    },
    milimeters: (value: string) => {
      const valNumber = Number(value?.replace(',', '.'))
      return (
        !value?.toString()?.length ||
        (valNumber >= 0 && valNumber <= 1000000) ||
        this.$t('productPackage.edit.category.productSets.upsert.validations.maxValue_1000000')
      )
    },
    centimeters: (value: string) => {
      const valNumber = Number(value?.replace(',', '.'))
      return (
        !value?.toString()?.length ||
        (valNumber >= 0 && valNumber <= 100000) ||
        this.$t('productPackage.edit.category.productSets.upsert.validations.maxValue_100000')
      )
    },
    meters: (value: string) => {
      const valNumber = Number(value?.replace(',', '.'))
      return (
        !value?.toString()?.length ||
        (valNumber >= 0 && valNumber <= 1000) ||
        this.$t('productPackage.edit.category.productSets.upsert.validations.maxValue_1000')
      )
    }
  }

  customRule() {
    switch (this.measurementUnit) {
      case 1:
        return [this.rulesInternal.milimeters]
      case 10:
        return [this.rulesInternal.centimeters]
      case 1000:
        return [this.rulesInternal.meters]
    }

    return [this.rulesInternal.allowAnything]
  }
}
